import { Button, styled } from "@mui/material";

export const StyledSetPassword = {
  Form: styled("form")(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing(2),
  })),
  Button: styled(Button)(({ theme }) => ({
    display: "flex",
    color: "white",
    margin: theme.spacing(2, 0, 2),
  })),
  progress: {
    width: "20px !important",
    height: "20px !important",
    margin: 1,
  },
  icon: {
    color: "#303030",
  },
  newPasswordInput: {
    paddingBottom: 10,
  },
};
